import api from './http'

const getList = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/personal-information', data)
}

const getDetail = (seq, callback, errorHandler) => {
  return api.getPromise('GET', `/api/personal-information/${seq}/detail`)
}

const getShareDetail = (data, callback, errorHandler) => {
  return api.getPromise('GET', '/api/personal-information/detail', data)
}

export default {
  getList,
  getDetail,
  getShareDetail
}
